import PDF from "./PDFIcon.svg?react";

export const PDFIcon = PDF;
